import React, { useState } from "react";
import { useForm, ValidationError } from "@formspree/react";
// import ReCAPTCHA from "react-google-recaptcha"; // Commented out for testing

function RSVPForm() {
  const [state, handleSubmit] = useForm("mjkwvjbj"); // Replace with your Formspree ID
  // const [recaptchaValue, setRecaptchaValue] = useState(null); // Commented out for testing

  // const onRecaptchaChange = (value) => {
  //   setRecaptchaValue(value);
  // };

  const handleFormSubmit = (event) => {
    // if (!recaptchaValue) { // Commented out for testing
    //   alert("Please complete the reCAPTCHA");
    //   event.preventDefault();
    //   return;
    // }
    handleSubmit(event);
  };

  if (state.succeeded) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-[#F1F1F1]">
        <div className="bg-white p-10 rounded-lg shadow-lg text-center max-w-md">
          <h2 className="text-4xl font-suranna font-medium text-[#36454F] mb-6">
            Thank You!
          </h2>
          <p className="text-lg font-montserrat font-medium text-gray-700 mb-6">
            Your RSVP has been received. We look forward to seeing you at the Gala!
          </p>
          <p className="text-sm font-montserrat text-gray-500 mb-6">
            If you have any questions, feel free to contact us at{" "}
            <a
              href="mailto:info@varsa.ca"
              className="text-[#E5B50B] font-bold underline hover:text-[#D4A10A]"
            >
              info@varsa.ca
            </a>.
          </p>
          <button
            onClick={() => window.location.href = "/"} // Redirect to home page
            className="bg-black hover:bg-[#E5B50B] text-white font-montserrat font-medium py-2 px-6 rounded-md transition duration-300"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <h1 className="text-4xl md:text-6xl text-center leading-8 font-suranna font-medium tracking-widest p-12 md:p-32">
        RSVP FOR OUR GALA
      </h1>
      <div className="flex flex-col justify-center md:pt-12 pb-32 bg-white">
        <div className="bg-[#F1F1F1] relative flex flex-col md:flex-row md:space-x-5 space-y-3 md:space-y-0 p-6 md:p-14 max-w-sm md:max-w-6xl mx-auto">
          <div className="w-full md:w-2/4 grid place-items-left">
            <p className="text-left leading-8 font-montserrat font-medium tracking-narrow pb-5">
              Join us for our Gala Grand Opening! Please fill out the form below to RSVP. We can't wait to celebrate with you! We will confirm a date and time in a direct email to you in the upcoming months.
            </p>
            
          </div>
          <div className="bg-[#F1F1F1] w-full md:w-3/4 text-left flex flex-col space-y-2">
            <form onSubmit={handleFormSubmit}>
              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <div>
                  <label htmlFor="first_name" className="block mb-2 font-montserrat font-medium">
                    First Name
                  </label>
                  <input
                    type="text"
                    id="first_name"
                    name="first_name"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="First name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="last_name" className="block mb-2 font-montserrat font-medium">
                    Last Name
                  </label>
                  <input
                    type="text"
                    id="last_name"
                    name="last_name"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="Last name"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block mb-2 font-montserrat font-medium">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="_replyto"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="name@mail.com"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block mb-2 font-montserrat font-medium">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="1234567891"
                    pattern="[0-9]{3}[0-9]{3}[0-9]{4}"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="company" className="block mb-2 font-montserrat font-medium">
                    Company Name
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="Enter your company name"
                  />
                </div>
                <div>
                  <label htmlFor="guests" className="block mb-2 font-montserrat font-medium">
                    Number of Guests
                  </label>
                  <input
                    type="number"
                    id="guests"
                    name="guests"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="Enter number of guests"
                    min="1"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="dietary" className="block mb-2 font-montserrat font-medium">
                    Dietary Restrictions
                  </label>
                  <textarea
                    id="dietary"
                    name="dietary"
                    className="bg-gray-50 border border-[#E5B50B] text-sm focus:ring-amber-500 focus:border-amber-500 block w-full p-2.5"
                    placeholder="Enter any dietary restrictions"
                  />
                </div>
              </div>
              {/* <ReCAPTCHA
                sitekey="yourRecaptchaSiteKey" // Replace with your actual site key
                onChange={onRecaptchaChange}
              /> */}
              <button
                type="submit"
                disabled={state.submitting}
                className="bg-black hover:bg-[#E5B50B] text-xs font-montserrat font-normal text-white py-2 px-4 w-full md:w-1/2 transform transition duration-500"
              >
                RSVP NOW
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RSVPForm;